/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main'
// import FacilitySelect from './views/OM/FacilitySelect'
// import RenewalApplication from './views/OM/RenewalApplication'
// import ContractorApplication from './views/asbestos/contractor/Application'
// import ContractorLanding from './views/asbestos/contractor/Landing'
// import ContractorApplicationSearch from './views/asbestos/contractor/ApplicationSearch'
// import PermitApplication from './views/permit/Application'
// import PermitContact from './views/permit/1-contact'
// import PermitSite from './views/permit/2-site'
// import PermitProject from './views/permit/3-project'
// import PermitAbatement from './views/permit/4-abatement'
// import PermitSignature from './views/permit/5-signature'
// import RevisionSearch from './views/revision/RevisionSearch'
// import RevisionSelectEdits from './views/revision/RevisionSelect'
// import RevisionForm from './views/revision/Revision'
// import RevisionInvalid from './views/revision/RevisionInvalid'
// import Checkout from './views/checkout/Checkout'
// import ThankYou from './views/checkout/Thanks'
// import PermitLanding from './views/permit/navigation/Landing'
// import PermitSearch from './views/permit/navigation/ApplicationSearch'
// import PermitSaved from './views/permit/navigation/ApplicationSaved'
// import PermitCancel from './views/permit/navigation/PermitCancel'
// import PermitApplicationReview from './views/permit/PermitApplicationReview'

Vue.use(Router)

/**
 * In the early days, if f modules were not assigned to a named webpack chunk then it would throw a bunch of webpack
 * errors. So I just assigned everything to a single webpack chunk since if i used more than one I would still get
 * errors. It's probably fixed in the current version of the vue-cli/webpack configuration since when this was
 * originally built it was with the beta vue-cli.
 */
export default new Router({
  routes: [
    // order matters, if a path matches multiple routes, then it picks the first one in this array
    {
      path: '/',
      name: 'Home',
      // component: Main
      redirect: {name: 'PermitLanding', params: {'projectType': 'demolition'}}
    },
    {
      path: '/operations-and-maintenance/select',
      name: 'OpAndMainSelect',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/OM/FacilitySelect')
      // component: FacilitySelect
    },
    {
      path: '/operations-and-maintenance/renewal/:facilityId',
      name: 'OpAndMainRenewal',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/OM/RenewalApplication')
      // component: RenewalApplication
    },
    {
      path: '/asbestos/contractor',
      name: 'AsbestosContractor',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/asbestos/contractor/Application')
      // component: ContractorApplication
    },
    {
      path: '/contractor',
      name: 'ContractorLanding',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/asbestos/contractor/Landing')
      // component: ContractorLanding
    },
    {
      path: '/contractor/search',
      name: 'ContractorApplicationSearch',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/asbestos/contractor/ApplicationSearch')
      // component: ContractorApplicationSearch
    },
    {
      path: '/permit/lookup',
      name: 'PermitLookup',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/navigation/PermitSearch')
    },
    {
      path: '/air',
      name: 'AirQualityLanding',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/AirQuality/AirQualityLanding')
    },
    {
      path: '/air/siterequest',
      name: 'SiteRequest',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/AirQuality/SiteRequest')
    },
    {
      path: '/air/siteauth',
      name: 'SiteAuthentication',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/AirQuality/SiteAuthentication')
    },
    {
      path: '/air/thankyou/:erid/:gatewayKey/:requestId',
      props: true,
      name: 'AirThankYou',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/AirQuality/ThankYou')
    },
    {
      path: '/air/thankyounofee',
      props: true,
      name: 'AirThankYouNoFee',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/AirQuality/ThankYouNoFee')
    },
    {
      path: '/air/srthankyou',
      name: 'SiteRequestThankYou',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/AirQuality/SiteRequestThankYou')
    },
    {
      path: '/air/equipmentfaq',
      name: 'EquipmentDetailsFAQ',
      component: () => import('./views/AirQuality/EquipmentDetailsFAQ')
    },
    {
      path: '/air/invoicethankyou/:gatewayKey',
      name: 'AirInvoiceThankYou',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/AirQuality/InvoiceThankYou')
    },
    {
      path: '/air/airapp/:siteNumber',
      name: 'AirApplication',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/AirQuality/AirApplication'),

      children: [
        {
          name: 'AirApplicationDefault',
          path: '',
          redirect: 'addequipment'
        },
        {
          path: 'addequipment',
          name: 'AddEquipment',
          component: () => import('./views/AirQuality/AddEquipment'),

          children: [
            {
              name: 'AddEquipmentDefault',
              path: '',
              redirect: { name: 'AddEquipmentDetails' }
            },
            {
              path: 'details',
              name: 'AddEquipmentDetails',
              props: true,
              component: () => import('./views/AirQuality/AddEquipmentDetails')
            },
            {
              path: 'equipmentfileupload',
              name: 'EquipmentFileUpload',
              props: true,
              component: () => import('./views/AirQuality/EquipmentFileUpload')
            },
            {
              path: 'reviewchanges',
              name: 'AddEquipmentReviewChanges',
              props: true,
              component: () => import('./views/AirQuality/ReviewSiteChanges')
            }]
        },
        //{
        //  path: 'siteequipment',
        //  name: 'SiteEquipment',
        //  component: () => import('./views/AirQuality/SiteEquipment')
        //},
        {
          path: 'accountstatements',
          name: 'AccountStatements',
          component: () => import('./views/AirQuality/AccountStatements'),
          children: [
            {
              name: 'AccountStatementsDefault',
              path: '',
              redirect: { name: 'SiteInvoices' }
            },
            {
              path: 'siteinvoices',
              name: 'SiteInvoices',
              component: () => import('./views/AirQuality/SiteInvoices')
            },
            {
              path: 'invoicecheckout',
              name: 'InvoiceCheckout',
              component: () => import('./views/AirQuality/InvoiceCheckout')
            },
            {
              path: 'viewstatement',
              name: 'ViewStatement',
              props: true,
              component: () => import('./views/AirQuality/ViewStatement')
            },
            {
              path: 'invoicecheckouttype',
              name: 'InvoiceCheckoutType',
              component: () => import('./views/AirQuality/InvoiceCheckoutType')
            }
          ]

        }     
      ]
    },
    {
      path: '/openburn',
      name: 'OpenBurnLanding',
      component: () => import('./views/OpenBurn/Landing')
    },
    {
      path: '/openburn/application',
      name: 'OpenBurnApplication',
      props: true,
      component: () => import('./views/OpenBurn/Application'),
      children: [
        {
          path: 'permitVerfication',
          name: 'PermitVerification',
          component: () => import('./views/OpenBurn/ApplicationPages/1-PermitVerification')
        },
        {
          path: 'applicantinfo',
          name: 'ApplicantInformation',
          component: () => import('./views/OpenBurn/ApplicationPages/2-ApplicantInfo')
        },
        {
          path: 'burninfo',
          name: 'BurnInformation',
          component: () => import('./views/OpenBurn/ApplicationPages/3-BurnInfo')
        },
        {
          path: 'additionalinfo',
          name: 'AdditionalInformation',
          component: () => import('./views/OpenBurn/ApplicationPages/4-AdditionalInfo')
        },
        {
          path: 'certificationinfo',
          name: 'CertificationInformation',
          component: () => import('./views/OpenBurn/ApplicationPages/5-CertificationInfo')
        },
      ]
    },
    {
      path: '/openburn/recapplication',
      name: 'OpenBurnRecreationalApplication',
      component: () => import('./views/OpenBurn/RecreationalApplication'),
      children: [
        {
          name: 'ApplicationRecDefault',
          path: '',
          redirect: { name: 'RecApplicationInformation' }
        },
        {
          path: 'applicantinfo',
          name: 'RecApplicationInformation',
          component: () => import('./views/OpenBurn/RecreationalApplicationPages/1-ApplicationInformation')
        },
        {
          path: 'recsignature',
          name: 'RecSignature',
          component: () => import('./views/OpenBurn/RecreationalApplicationPages/2-Signature')
        }
      ]
    },
    {
      path: '/openburn/recreview',
      name: 'OpenBurnRecReview',
      props: true,
      component: () => import('./views/OpenBurn/RecreationalApplicationPages/Review')
    },
    {
      path: '/openburn/recthankyou',
      name: 'OpenBurnThankYouRec',
      props: true,
      component: () => import('./views/OpenBurn/ThankYouPages/ThankYouRec')
    },
    {
      path: '/openburn/review',
      name: 'OpenBurnReview',
      component: () => import('./views/OpenBurn/ApplicationPages/Review')
    },
    {
      path: '/openburn/appsearch',
      name: 'OpenBurnApplicationSearch',
      component: () => import('./views/OpenBurn/ApplicationSearch')
    },
    {
      path: '/openburn/applicationSaved',
      name: 'OpenBurnPermitApplicationSaved',
      props: true,
      component: () => import('./views/OpenBurn/ThankYouPages/ApplicationSaved')
    },
    // Application Create/Edit
    {
      path: '/:projectType/application',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/Application'),
      // component: PermitApplication,
      children: [
        {
          name: 'PermitApplication',
          path: '',
          redirect: 'contact'
        },
        {
          path: 'contact',
          component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/1-contact')
          // component: PermitContact
        },
        {
          path: 'site',
          component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/2-site')
          // component: PermitSite
        },
        {
          path: 'project',
          component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/3-project')
          // component: PermitProject
        },
        {
          path: 'materials',
          component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/6-materials')
          // component: PermitProject
        },
        {
          path: 'asbestos',
          component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/4-abatement')
          // component: PermitAbatement
        },
        {
          path: 'signature',
          component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/5-signature')
          // component: PermitSignature
        }
      ]
    },
    // Application Create/Edit
    {
      path: '/:projectType/materialsReview',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/DDDInformationApplication'),
      // component: PermitApplication,
      children: [
        {
          name: 'MaterialsReview',
          path: '',
          redirect: 'materials'
        },
        {
          path: 'materials',
          component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/DDDInformationForm')
          // component: DDDInformationForm
        }
      ]
    },
    // Revision Navigation/Create
    {
      path: '/:projectType/revision/search',
      name: 'RevisionSearch',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/revision/RevisionSearch')
      // component: RevisionSearch
    },
    {
      path: '/:projectType/revision/selectEdits/:id',
      name: 'RevisionSelect',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/revision/RevisionSelect')
      // component: RevisionSelectEdits
    },
    {
      path: '/:projectType/revision/:id',
      name: 'RevisionForm',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/revision/Revision'),
      // component: RevisionForm,
      props: true
    },
    {
      path: '/:projectType/revision/invalid',
      name: 'RevisionInvalid',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/revision/RevisionInvalid'),
      // component: RevisionInvalid,
      props: true
    },
    {
      path: '/:projectType/DDDInformation/search',
      name: 'DDDInformation',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/navigation/DDDInformation')
      // component: RevisionSearch
    },
    {
      path: '/:projectType/search',
      name: 'DDDInformationForm',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/DDDInformationForm')
      // component: RevisionSearch
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/checkout/Checkout')
      // component: Checkout
    },
    {
      path: '/air/checkout',
      name: 'AirCheckout',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/checkout/AirCheckout')
      // component: AirCheckout
    },
    {
      path: 'openburn/checkout',
      name: 'OpenBurnCheckout',
      props: true,
      component: () => import('./views/OpenBurn/Checkout')
    },
    {
      path: '/thankYou/:shoppingCart',
      name: 'Thanks',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/checkout/Thanks')
      // component: ThankYou
    },
    {
      path: '/omThankYou/:feei',
      name: 'OMThankYou',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/checkout/OMThankYou')
      // component: OMThankYou
    },
    {
      path: '/thankYou',
      name: 'GenericThanks',
      component: () => import(/* webpackChunkName: "group-foo" */ './views/checkout/GenericThankYou')
    },
    {
      path: '/openburn/thankyou/:transactionId',
      name: 'OpenBurnThankYou',
      props: true,
      component: () => import('./views/OpenBurn/ThankYouPages/ThankYou')
    },
    {
      path: '/openburn/nfthankyou',
      name: 'OpenBurnNoFeeThankYou',
      props: true,
      component: () => import('./views/OpenBurn/ThankYouPages/ThankYouNoFee')
    },
    {
      path: '/:projectType',
      name: 'PermitLanding',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/navigation/Landing')
      // component: PermitLanding
    },
    {
      path: '/:projectType/search',
      name: 'PermitSearch',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/navigation/ApplicationSearch')
      // component: PermitSearch
    },
    {
      path: '/:projectType/applicationSaved',
      name: 'PermitApplicationSaved',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/navigation/ApplicationSaved')
      // component: PermitSaved
    },
    {
      path: '/:projectType/dddiApplicationSaved',
      name: 'DDDIApplicationSaved',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/navigation/DDDIApplicationSaved')
      // component: PermitSaved
    },
    {
      path: '/:projectType/cancel',
      name: 'PermitApplicationCancel',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/navigation/PermitCancel')
      // component: PermitCancel
    },
    {
      path: '/:projectType/review',
      name: 'PermitApplicationReview',
      props: true,
      component: () => import(/* webpackChunkName: "group-foo" */ './views/permit/PermitApplicationReview')
      // component: PermitApplicationReview
    }
  ]
})
